export const OnboardingRequestUrl = `onboarding-employee`;
export const OnboardingApproveUrl = `onboarding-approver`;
export const TransferRequestUrl = `transfer-employee`;
export const TransferApproveUrl = `transfer-approver`;
export const ApplicationAccessUrl = `application-access`;
export const DataServiceUrl = `data-service`;
export const MiscellaneousServiceUrl = `miscellaneous-service`;
export const ResourceServiceUrl = `resource-service`;
export const SupplierPaymentRequestUrl = `supplier-payment`;
export const SupplierPaymentApproveUrl = `supplier-payment-approver`;
export const IncidentApproveUrl = `incident-approver`;
export const RequestsTasksTabUrl = `?tab=tasks`;
export const RequestsObservationTabUrl = `?tab=observations`;
export const RequestApprovalResult = {
  Pending: 0,
  Approved: 1,
  Rejected: 2,
  Cancelled: 3
};
export const RequestsStatus = {
  Default: 0,
  InProgress: 1,
  Completed: 2,
  Rejected: 3,
  Cancelled: 4
};

export const RequestWorkflowType = {
  Onboarding: 1,
  Transfer: 2
};

export const CurrentApproveType = {
  OnTheFly: 'WorkflowAssigned'
};

export const CONFIRMATION_MESSAGE_PREFIX = 'Are you sure you want to';
